module.exports = __webpack_public_path__ + "img/3891684.ed6a957b.png";